import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'

// 开发环境模拟数据（仅拦截异步生成链路，其余请求透传）
if (import.meta.env.VITE_ENABLE_MOCK === 'true') {
  import('./mocks/mock.ts')
}

import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  //   <App />
  // </StrictMode>,
  <App />
)
